/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Miradi Share Organization info (new)
 */
import { ValidateUtils } from 'app/shared/utils';

export class OrganizationInfoNew { 
    /**
     * Organization name
     */
    name: string;
    /**
     * Organization short name
     */
    shortName: string;
    /**
     * Flag indicating whether Organization is enabled
     */
    isEnabled: boolean;
    /**
     * Email domains for SSO authentication (e.g., example.com)
     */
    domains?: Array<string> | null;
    /**
     * Organization website URL
     */
    url?: string | null;

    constructor(item?: Partial<OrganizationInfoNew>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            name: {
                
                minLength: 1,
                maxLength: 200,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.name : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, 1, 200);
                    }

                    return result;
                }
            },
            shortName: {
                
                minLength: 1,
                maxLength: 30,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.shortName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, 1, 30);
                    }

                    return result;
                }
            },
            isEnabled: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.isEnabled : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            domains: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.domains : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            url: {
                type: 'uri',
                
                maxLength: 500,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.url : itemOrValue;

                    if (itemOrValue?.url != null) {
                        if (itemOrValue.url === '') {
                            itemOrValue.url = undefined;
                        } else if (['int32', 'int64'].indexOf('uri') >= 0) {
                            itemOrValue.url = parseInt(itemOrValue.url.toString(), 10);
                        } else if (['float'].indexOf('uri') >= 0) {
                            itemOrValue.url = parseFloat(itemOrValue.url.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'uri');
                    if (['uuid'].indexOf('uri') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, 500);
                    }

                    return result;
                }
            },
            isValid: OrganizationInfoNew.isValid,
        };
    }

    static isValid(obj: OrganizationInfoNew): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = OrganizationInfoNew.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.name.isValid(item);
            result = result && validationObject.shortName.isValid(item);
            result = result && validationObject.isEnabled.isValid(item);
            result = result && validationObject.domains.isValid(item);
            result = result && validationObject.url.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

